/* RESPONSIBLE TEAM: team-knowledge-foundations */

import Model, { belongsTo } from '@ember-data/model';
import { attr } from '@ember-data/model';
import type Setting from 'embercom/models/consent-banners/setting';

export default class Category extends Model {
  @attr('string') declare appId: string;
  @attr('string') declare consentBannerSettingId: string;
  @attr('boolean') declare necessary: boolean;
  @attr('boolean') declare functional: boolean;
  @attr('boolean') declare advertisement: boolean;
  @attr('boolean') declare performance: boolean;

  @belongsTo('consent-banners/setting', { async: false })
  declare setting: Setting;
}
